// frontend/src/services/championshipPlayerService.js
import { configuredAxios as api } from './axiosConfig';

const championshipPlayerService = {
  /**
   * Busca os detalhes de uma inscrição específica de jogador em um campeonato.
   * @param {string} championshipPlayerId - O ID do documento ChampionshipPlayer.
   * @returns {Promise<object>} Os dados da inscrição, incluindo jogador e time populados.
   */
  getChampionshipPlayerById: async (championshipPlayerId) => {
    try {
      const response = await api.get(`/championship-player/${championshipPlayerId}`);
      // Assumindo que o backend retorna { success: true, data: champPlayer }
      return response.data.data;
    } catch (error) {
      console.error(`Erro ao buscar inscrição de jogador ${championshipPlayerId}:`, error.response?.data || error.message);
      throw error.response?.data || error;
    }
  },

  /**
   * Atualiza a posição e/ou número da camisa de uma inscrição de jogador em um campeonato.
   * @param {string} championshipPlayerId - O ID do documento ChampionshipPlayer.
   * @param {object} data - Objeto contendo { position, shirtNumber }.
   * @returns {Promise<object>} Os dados atualizados da inscrição.
   */
  updateChampionshipPlayer: async (championshipPlayerId, data) => {
    try {
      const response = await api.patch(`/championship-player/${championshipPlayerId}`, data);
      // Assumindo que o backend retorna { success: true, data: updatedChampPlayer }
      return response.data.data;
    } catch (error) {
      console.error(`Erro ao atualizar inscrição de jogador ${championshipPlayerId}:`, error.response?.data || error.message);
      throw error.response?.data || error;
    }
  }
};

export default championshipPlayerService;